module.exports = __webpack_public_path__ + "img/mingzhi_icon_04.e13af124.png";